import { faCalendar, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import blogsData from '../../data';
import './SingleBlog.css'


const SingleBlogComponent = () => {
    const { url } = useParams();
    const [blogdetails, setblogdetails] = useState(null);
    useEffect(() => {
        const singleblog = blogsData.filter(x => x.postUrl === `/blog/${url}`)
        setblogdetails(singleblog && singleblog[0])
    }, [url]);
    return(
        <section className="blog-widget-section">
            {blogdetails &&
            <>
            <div className="blog-overlay-section">
                <div className="blog-overlay" style={{backgroundImage: `url("../img/single.svg")`, zIndex: 0}}>
                </div>
            </div>
            <div className="single-blog-container">
                
                <div className="blog-single-main">
                    <div className="title">
                        <h2>{blogdetails.title}</h2>
                    </div>
                    <div className="author-info">
                        <div className="author">
                            <FontAwesomeIcon icon={faUser} />
                            <p>{blogdetails.authorName}</p>
                        </div>
                        <div className="written-date" style={{borderLeft: "1px solid #FFF", paddingLeft: "25px"}}>
                            <FontAwesomeIcon icon={faCalendar} />
                            <p>{blogdetails.postDate}</p>
                        </div>
                    </div>
                    {blogdetails.featureImage&& 
                    <div className="feature-image" style={{backgroundImage: `url(${blogdetails.featureImage})`, height: `${blogdetails.featureImageHight ? blogdetails.featureImageHight : 500}px`, borderRadius: "6px", marginBottom: "50px"}} />}
                    <div className="description" dangerouslySetInnerHTML={{__html: blogdetails.description}}>
                    
                    </div>
                </div>
            </div>
            </>}
        </section>
    )
};

export default SingleBlogComponent;
